import {type RouteLocationStringParam} from 'vue-router';

const GlobalNewsList    = () => import('../views/global-news/GlobalNewsList.vue');
const GlobalNewsEdit    = () => import('../views/global-news/GlobalNewsEdit.vue');
const GlobalNewsPreview = () => import('../views/global-news/GlobalNewsPreview.vue');

export const globalNewsBasicBreadcrumb: Breadcrumb = {
    label: 'Startseitennachrichten',
    href: {name: 'global-news'},
};

let meta = {module: 'installer'};

let globalNews = [
    {
        name: 'global-news-edit',
        path: '/installer/news/edit/id/:id',
        component: GlobalNewsEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
        meta,
    },
    {
        name: 'global-news-copy',
        path: '/installer/news/edit/copy/:copy',
        component: GlobalNewsEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                copy: parseInt(route.params.copy) || 0,
            };
        },
        meta,
    },
    {
        name: 'global-news-preview',
        path: '/installer/news/preview/id/:id',
        component: GlobalNewsPreview,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
        meta,
    },
    {
        name: 'global-news',
        path: '/installer/news',
        component: GlobalNewsList,
        meta,
    },
    {
        path: '/installer/news/:wildcard*',
        redirect: {name: 'global-news'},
        meta,
    },
];

export default globalNews;